export class ErrorBase {
    id: string;
    message: string;
    errorKey: string;
    errorTypeId:string;
    fieldName:string;
    

    constructor(id: string,message: string, errorCode: string, errorTypeId:string = undefined, fieldName:string = undefined) {
        this.id = id;
        this.message = message;
        this.errorKey = errorCode; // todo: critical rename to localizationKey
        this.errorTypeId =errorTypeId;
        this.fieldName = fieldName;
    }
}
